import { render, staticRenderFns } from "./salesCategoryList.vue?vue&type=template&id=2f62a850&scoped=true"
import script from "./salesCategoryList.vue?vue&type=script&lang=js"
export * from "./salesCategoryList.vue?vue&type=script&lang=js"
import style0 from "./salesCategoryList.vue?vue&type=style&index=0&id=2f62a850&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f62a850",
  null
  
)

export default component.exports